import { mapActions, mapGetters, mapMutations } from 'vuex'
import general from '../general/index.vue'

export default {
  name: 'setting-course-categories-dialog-view',
  data () {
    return {
      dialog: true,
      activeTab: 'general'
    }
  },
  components: {
    general
  },
  watch: {
    openDialogView () {
      this.dialog = this.openDialogView
    }
  },
  computed: {
    ...mapGetters({
      currentItem: 'settingNiches/currentItem',
      openDialogView: 'settingNiches/openDialogView',
      editId: 'settingNiches/editId',
      isLoading: 'settingNiches/isLoading'
    }),
    tabs () {
      return [
        {
          name: 'General',
          slug: 'general',
          id: 1
        }
      ]
    }
  },
  created () {
    if (this.editId) {
      this.fetchItem()
    }
  },
  methods: {
    ...mapActions({
      fetchItem: 'settingNiches/GET_LIST_ITEM'
    }),
    ...mapMutations({
      changeDialogView: 'settingNiches/CHANGE_DIALOG_VIEW',
      changeEditId: 'settingNiches/CHANGE_EDIT_ID',
      setContent: 'settingNiches/SET_ITEM'
    }),
    changeCloseDialog () {
      this.dialog = false
      this.changeDialogView(false)
      this.changeEditId('')
    },

    save () {
      this.$refs['general'].$emit('event-save');
    }
  },
  destroyed () {
    this.setContent(null)
  }
}
